<div class="phone-input" [class.phone-input--disabled]="disabled">
  <button
    type="button"
    class="phone-input__country"
    [disabled]="disabled"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
    (click)="toggleOpen()">
    @if (selectedCountry) {
      <span class="fi phone-input__flag" [class]="'fi-' + selectedCountry.iso2"></span>
    } @else {
      <svg class="phone-input__flag phone-input__flag--placeholder" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.5" />
        <ellipse cx="12" cy="12" rx="4" ry="9" fill="none" stroke="currentColor" stroke-width="1.5" />
        <path d="M3 12h18M4.5 7.5h15M4.5 16.5h15" fill="none" stroke="currentColor" stroke-width="1.5" />
      </svg>
    }
    <svg class="phone-input__caret" viewBox="0 0 12 8" width="10" height="7" aria-hidden="true">
      <path
        d="M1 1.5 6 6.5 11 1.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
    @if (selectedCountry) {
      <span class="phone-input__dial">+{{ selectedCountry.dialCode }}</span>
    }
  </button>

  <span class="phone-input__separator" aria-hidden="true"></span>

  <input
    class="phone-input__number"
    type="tel"
    inputmode="numeric"
    autocomplete="off"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.maxlength]="maxDigits"
    [value]="value.number"
    (input)="onNumberInput($event)"
    (blur)="onNumberBlur()" />

  @if ((selectedCountry || value.number) && !disabled) {
    <button type="button" class="phone-input__clear" aria-label="Clear phone number" (click)="clear()">
      <svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true">
        <path
          d="M1.5 1.5 10.5 10.5M10.5 1.5 1.5 10.5"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round" />
      </svg>
    </button>
  }

  @if (isOpen) {
    <div class="phone-input__panel">
      <div class="phone-input__search-wrap">
        <svg class="phone-input__search-icon" viewBox="0 0 16 16" width="15" height="15" aria-hidden="true">
          <circle cx="7" cy="7" r="5.25" fill="none" stroke="currentColor" stroke-width="1.5" />
          <path d="M11 11 14.5 14.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <input
          class="phone-input__search"
          type="text"
          autocomplete="off"
          placeholder="Search country or code..."
          aria-label="Search country or code"
          [value]="searchTerm"
          (input)="onSearchChange($any($event.target).value)"
          (keydown)="onSearchKeydown($event)" />
      </div>
      <div class="phone-input__list" role="listbox" aria-label="Countries" (mousedown)="$event.preventDefault()">
        @for (country of filteredCountries; track country.id; let i = $index) {
          <button
            type="button"
            role="option"
            class="phone-input__option"
            [class.phone-input__option--active]="i === highlightIndex"
            [attr.aria-selected]="country.id === value.countryId"
            (click)="selectCountry(country)">
            <span class="fi phone-input__flag" [class]="'fi-' + country.iso2"></span>
            <span class="phone-input__option-name">{{ country.name }}</span>
          </button>
        } @empty {
          <div class="phone-input__option phone-input__option--message">No countries found</div>
        }
      </div>
    </div>
  }
</div>
